(function($) {
    $.widget("ca.caDialog", $.ui.dialog, {
        options: {
            showCloseButton: true,
            className: 'ca-dialog',
            width: '535',
            resizable: false,
            modal: true,
            staticForm: true,
            caProUI: false,
            onCloseCallbacks: [],
            create: function() {
                var dialog = $(this).parent();
                dialog.removeClass('ui-corner-all').removeClass('ui-widget-content').removeClass('ui-widget');
                dialog.addClass('ca-dialog');
                dialog.addClass('ca-pro-ui');
                dialog.children().wrapAll('<div class="block" />');

                var header = dialog.find('.ui-dialog-titlebar');
                header.removeClass('ui-widget-header').removeClass('ui-corner-all');
                header.find('.ui-dialog-titlebar-close').remove();
                header.addClass('block-title');
                var title = $('<h2>').html(header.find('.ui-dialog-title').text());
                header.append(title);
                header.find('.ui-dialog-title').remove();

                $('<div class="block-options pull-right">' +
                    '<a href="javascript:void(0)" class="btn btn-alt btn-sm btn-default ca-titlebar-close">' +
                    '<i class="fa fa-times"></i>' +
                    '</a>' +
                    '</div>')
                    .appendTo(header);

                var content = dialog.find('.ui-dialog-content');
                content.wrap('<div class="dialog-content">');

                var closeButton = header.find('.ca-titlebar-close');
                closeButton.on('click', function(){
                    if (typeof $.cardswipe === 'function') {
                        $.cardswipe('disable');
                    }
                    content.remove();
                });
            },
            drag: function() {
                var optWidth = $(this).data().caCaDialog && $(this).data().caCaDialog.options.width;
                if (optWidth) {
                    $(this).closest('.ca-dialog').css('width', optWidth);
                }
            },
        },

        open: function() {
            var self = this;
            // For old forms that are being created just one time. New forms should be received by an ajax request
            if (this.options.staticForm) {
                this.element.parents('.ca-dialog').find('.ca-titlebar-close')
                    .off('click')
                    .on('click', function () {
                            self.element.caDialog('close');
                        }
                    );
            }
            if (!this.options.caProUI) {
                this.element.parents('.ca-dialog').removeClass('ca-pro-ui');
                this.element.parents('.ca-dialog').find('.block-title').addClass('ca-pro-ui');
            }

            if (this.options.className != undefined && this.options.className) {
                this.element.parents('.ui-dialog').removeClass('ca-dialog').addClass(this.options.className);
            }

            if (this.options.beforeOpen != null) {
                if (!this._trigger('beforeOpen')) {
                    return false;
                }
            }

            if (!this.options.showCloseButton) {
                this.element.parents('.ui-dialog').find('.block-options').remove();
            }

            $.ui.dialog.prototype.open.apply(this, arguments);

            if (this.options.showCloseButton == false) {
                this.element.parents('.ui-dialog').find('.ca-titlebar-close').remove();
            }

            if (this.options.title) {
                this.element.parents('.ui-dialog').find('.ui-dialog-titlebar > h2').html(this.options.title);
            }
        },

        close: function() {
            // For old forms that are being created just once. New forms should be received by an ajax request
            if (!this.options.staticForm) {
                this.element.remove();
            }
            $.ui.dialog.prototype.close.apply(this, arguments);
        },

        center: function() {
            $.ui.dialog.prototype.option.apply(this, ["position", { my: 'center', at: 'center', of: window }]);
        },

        destroy: function() {
            $.ui.dialog.prototype.destroy.apply(this, arguments);
        },
        // Addresses http://dev.ckeditor.com/ticket/10269
        _moveToTop: function ( event, silent ) {
            if ( !event || !this.options.modal ) {
                this._super( event, silent );
            }
        }
    });

    $.caDialogCloseAll = function() {
        if (typeof $.cardswipe === 'function') {
            $.cardswipe('disable');
        }
        $('.ui-dialog-content').remove();
    };

    /**
     * UI 1.10.2 throws error if widget is not initialized or method not exists.
     * @see http://bugs.jqueryui.com/ticket/5972
     */
    $.fn.caDialog = function (options) {
        var fullName = 'ca-caDialog';

        arguments[arguments.length] = 1;
        var isMethodCall = typeof options === "string",
            args = $.fn.slice.apply($.fn, arguments),
            returnValue = this;

        // allow multiple hashes to be passed on init
        options = !isMethodCall && args.length ?
            $.widget.extend.apply(null, [options].concat(args)) :
            options;

        if (isMethodCall) {
            this.each(function () {
                var methodValue,
                    instance = $.data(this, fullName);
                if (!instance) {
                    return; //$.error( "cannot call methods on " + name + " prior to initialization; " +
                    // "attempted to call method '" + options + "'" );
                }
                if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
                    return; //$.error( "no such method '" + options + "' for " + name + " widget instance" );
                }
                methodValue = instance[options].apply(instance, args);
                if (methodValue !== instance && methodValue !== undefined) {
                    returnValue = methodValue && methodValue.jquery ?
                        returnValue.pushStack(methodValue.get()) :
                        methodValue;
                    return false;
                }
            });
        } else {
            this.each(function () {
                var instance = $.data(this, fullName);
                if (instance) {
                    instance.option(options || {})._init();
                } else {
                    $.data(this, fullName, new $.ca.caDialog(options, this));
                }
            });
        }

        return returnValue;
    };

})(jQuery);
